import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6da24f5f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6da24f5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da24f5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da24f5f')) {
      api.createRecord('6da24f5f', component.options)
    } else {
      api.reload('6da24f5f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6da24f5f&scoped=true", function () {
      api.rerender('6da24f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/store/index.vue"
export default component.exports